<button class="btn btn-md navbar-btn btn-synchro btn-success" (click)="demandeRafraichissement()">
	<i class="fa fa-lg fa-refresh" aria-hidden="true" alt="Synchroniser" title="Synchroniser"></i>
	<small *ngIf="isUserCce$ | async">&nbsp;{{ countdown }}</small>
</button>